import { createReducer, on } from '@ngrx/store';
import { formatISO } from 'date-fns';
import { ServiceTaskTab } from 'src/app/types/service-task.types';
import { clearStateRequested } from '../auth/auth.actions';
import * as serviceGraphActions from '../service-graph/service-graph.actions';
import * as serviceTaskActions from './service-task.actions';

export interface State {
	sortInboxAscending: boolean;
	inboxDateFilter: string | null;
	sortScheduledAscending: boolean;
	scheduledDateFilter: string;
	selectedServiceTaskTab: ServiceTaskTab;
}

export const initialState: State = {
	sortInboxAscending: true,
	inboxDateFilter: null,
	sortScheduledAscending: true,
	scheduledDateFilter: '',
	selectedServiceTaskTab: ServiceTaskTab.Inbox
}

export const serviceTaskReducer = createReducer(
	initialState,
	on(serviceGraphActions.serviceGraphLoaded, (state) => ({
		...state,
		inboxDateFilter: null,
		scheduledDateFilter: formatISO(new Date(), { representation: 'date' })
	})),
	on(serviceTaskActions.inboxSortToggled, (state) => ({
		...state,
		sortInboxAscending: !state.sortInboxAscending
	})),
	on(serviceTaskActions.inboxDateFilterChanged, (state, { dateFilter }) => ({
		...state,
		inboxDateFilter: dateFilter
	})),
	on(serviceTaskActions.scheduledDateFilterChanged, (state, { dateFilter }) => ({
		...state,
		scheduledDateFilter: dateFilter
	})),
	on(serviceTaskActions.scheduledSortToggled, (state) => ({
		...state,
		sortScheduledAscending: !state.sortScheduledAscending
	})),
	on(serviceTaskActions.serviceTaskTabChanged, (state, { selectedTab }) => ({
		...state,
		selectedServiceTaskTab: selectedTab
	})),
	on(serviceGraphActions.unsubscribeServiceRequested, () => initialState),
	on(clearStateRequested, () => initialState)
);
